import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Layout from '@/components/Layout';
import ProtectedRoute from '@/components/ProtectedRoute';

const Login          = lazy(() => import('@/pages/Login'));
const Dashboard      = lazy(() => import('@/pages/Dashboard'));
const Profile        = lazy(() => import('@/pages/Profile'));
const Notifications  = lazy(() => import('@/pages/Notifications'));
const SparkBot       = lazy(() => import('@/pages/SparkBot'));
const Academy        = lazy(() => import('@/pages/Academy'));
const Classes        = lazy(() => import('@/pages/Classes'));
const Join           = lazy(() => import('@/pages/Join'));
const StudentRoom    = lazy(() => import('@/pages/StudentRoom'));

const ToolGrid       = lazy(() => import('@/pages/teacher-suite/ToolGrid'));
const ToolDetail     = lazy(() => import('@/pages/teacher-suite/ToolDetail'));
const RunHistory     = lazy(() => import('@/pages/teacher-suite/RunHistory'));

const UserManagement = lazy(() => import('@/pages/admin/UserManagement'));
const ISDManagement  = lazy(() => import('@/pages/admin/ISDManagement'));

function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-[40vh]">
      <span className="inline-flex gap-1.5">
        <span className="w-2 h-2 rounded-full bg-purple-400 animate-bounce" style={{ animationDelay: '0ms' }} />
        <span className="w-2 h-2 rounded-full bg-orange-400 animate-bounce" style={{ animationDelay: '120ms' }} />
        <span className="w-2 h-2 rounded-full bg-green-400 animate-bounce" style={{ animationDelay: '240ms' }} />
      </span>
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* ── Public routes (no auth) ── */}
        <Route path="/login" element={<Login />} />
        <Route path="/join" element={<Join />} />
        <Route path="/student-room" element={<StudentRoom />} />

        {/* ── Authenticated routes ── */}
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/notifications" element={<Notifications />} />

            <Route element={<ProtectedRoute allow={['teacher', 'school_admin', 'isd_admin', 'super_admin']} />}>
              <Route path="/teacher-suite" element={<ToolGrid />} />
              <Route path="/teacher-suite/history" element={<RunHistory />} />
              <Route path="/teacher-suite/:slug" element={<ToolDetail />} />
              <Route path="/analytics" element={<RunHistory />} />
            </Route>

            <Route element={<ProtectedRoute allow={['teacher']} />}>
              <Route path="/classes" element={<Classes />} />
            </Route>

            <Route element={<ProtectedRoute allow={['student']} />}>
              <Route path="/sparkbot" element={<SparkBot />} />
              <Route path="/learn" element={<Academy />} />
            </Route>

            <Route element={<ProtectedRoute allow={['school_admin', 'isd_admin', 'super_admin']} />}>
              <Route path="/admin/users" element={<UserManagement />} />
            </Route>

            <Route element={<ProtectedRoute allow={['super_admin']} />}>
              <Route path="/admin/isds" element={<ISDManagement />} />
            </Route>
          </Route>
        </Route>

        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Suspense>
  );
}
